import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import ThankYou from "@/pages/ThankYou";
import About from "@/pages/About";
import Customizer from "@/pages/Customizer";
import Beauty from "@/pages/Beauty";
import { BerryAssistant } from "@/components/BerryAssistant";
import { BerryRunner } from "@/components/BerryRunner";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/about" element={<About />} />
              <Route path="/beauty" element={<Beauty />} />
              <Route path="/customizer" element={<Customizer />} />
              <Route path="/customizer/:slug" element={<Customizer />} />
            </Routes>
          </Layout>
          <BerryAssistant />
          <BerryRunner />
          <Toaster position="top-center" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
